import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { BitmapText, Container, useApp } from '@pixi/react';
import gsap from 'gsap';

import { gameResourcesService } from '../../../../services/gameResourcesService';

import { Spine } from '../../../../core/classes/spine';
import { isoStandard } from '../../../../core/helpers/isoStandard';

import { gameStore } from '../../../../store/gameStore';

let timeLine;

const FreeSpinTotalWinPopup = observer(({ containerConfig }) => {
  const [totalWinAmount, setTotalWinAmount] = useState('');
  const { stage } = useApp();
  const bitmapRef = useRef(null);
  const freeSpinTotalWinPopupRef = useRef(null);
  const { gameFreeSpinTotalWin, isSpinStart } = gameStore;

  useEffect(() => {
    if (freeSpinTotalWinPopupRef.current) {
      const freeSpinTotalWinPopup = new Spine({ key: 'freeSpinTotalWinPopup' });
      gameResourcesService.setGameFreeSpinTotalWinPopupSpine(freeSpinTotalWinPopup);
      freeSpinTotalWinPopup.addChildToSlot('winPopupNumbers', bitmapRef.current);
      freeSpinTotalWinPopupRef.current.addChild(freeSpinTotalWinPopup);
    }
  }, [freeSpinTotalWinPopupRef]);

  useEffect(() => {
    if (!freeSpinTotalWinPopupRef.current) return;
    timeLine && timeLine.kill();
    timeLine = gsap.timeline();
    setTotalWinAmount('');
    bitmapRef.current.textContent = ''
    timeLine.to(bitmapRef.current, {
      textContent: gameFreeSpinTotalWin,
      duration: 0.7,
      ease: 'none',
      snap: { textContent: 0.01 },
      stagger: {
        each: 1,
        onUpdate: function () {
          setTotalWinAmount(isoStandard(this.targets()[0].textContent, true));
        },
        onComplete: function () {
          setTotalWinAmount(isoStandard(+gameFreeSpinTotalWin, true));
          timeLine && timeLine.kill();
        },
      },
    });
  }, [bitmapRef, gameFreeSpinTotalWin]);

  const hideGameFreeSpinTotalWinPopup = useCallback(() => {
    if (!isSpinStart){
      gameResourcesService.hideGameFreeSpinTotalWinPopupSpine();
    }
  }, [isSpinStart]);

  useEffect(() => {
    stage.addEventListener('pointerup', hideGameFreeSpinTotalWinPopup, true);
    return () => {
      stage.removeEventListener('pointerup', hideGameFreeSpinTotalWinPopup, true);
    };
  }, [hideGameFreeSpinTotalWinPopup, stage]);

  return (
    <>
      <Container
        interactive
        {...containerConfig}
        name='FreeSpinTotalWinPopup'
        ref={freeSpinTotalWinPopupRef}
        onclick={hideGameFreeSpinTotalWinPopup}
      />
      <BitmapText
        y={-100}
        anchor={0.5}
        align='center'
        ref={bitmapRef}
        text={totalWinAmount}
        style={{ fontName: 'numbersWinPopup' }}
      />
    </>
  );
});

export default FreeSpinTotalWinPopup;
